import { render, staticRenderFns } from "./modalAlteracaoPrazo.vue?vue&type=template&id=0126e60a"
import script from "./modalAlteracaoPrazo.vue?vue&type=script&lang=js"
export * from "./modalAlteracaoPrazo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports